module.exports = "https://static.wmbcdn.com/uniweb/images/8a59cbb8e0d8b7222812bab1cad370e9.svg";